import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";
import { FiMoreVertical } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import EmptyStateCentered from "../static/EmptyStateCentered";

const BlockProfilesListPage = () => {
  const [blockedProfiles, setBlockedProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpenId, setMenuOpenId] = useState(null);

  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  const fetchBlockedProfiles = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/block-profile-view/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setBlockedProfiles(res.data);
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to fetch blocked profiles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlockedProfiles();
  }, []);

  const handleUnblockProfile = (blockedId) => {
    confirmAlert({
      title: "Confirm Unblock",
      message: "Are you sure you want to unblock this profile?",
      buttons: [
        {
          label: "Yes, Unblock",
          onClick: async () => {
            try {
              await axios.post(
                "/api/unblock-profile/",
                { blocked_id: blockedId },
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      "accessToken"
                    )}`,
                  },
                }
              );
              toast.success("Profile unblocked successfully.");
              setBlockedProfiles((prev) =>
                prev.filter((profile) => profile.user.id !== blockedId)
              );
            } catch (error) {
              console.error(error.response?.data || error.message);
              toast.error("Failed to unblock profile.");
            }
          },
        },
        { label: "Cancel" },
      ],
    });
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <div className="p-4 w-full max-w-3xl mx-auto overflow-y-auto">
      {/* <h2 className="text-lg font-semibold mb-4">Blocked Profiles</h2> */}
      {blockedProfiles.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">
          {/* You have not blocked any profiles. */}
          <EmptyStateCentered />
        </p>
      ) : (
        <div className="flex flex-col gap-4">
          {blockedProfiles.map((match) => (
            <div
              key={match.id}
              className="bg-white rounded shadow p-4 flex flex-col sm:flex-row items-center sm:items-start gap-4 relative"
            >
              <Link
                to={`/profile/${match.user.id}`}
                className="flex-shrink-0 relative"
              >
                {dayjs().diff(dayjs(match.created_at), "day") <= 30 && (
                  <div className="absolute -top-7 -left-6 w-14 transform -rotate-50 bg-pink-600 text-white text-[10px] font-semibold text-center rounded py-0.5 shadow z-17">
                    NEWLY <br /> JOINED
                  </div>
                )}

                <img
                  src={
                    match.photo || require("../../assets/default_image.webp")
                  }
                  alt={`${match.user.first_name}`}
                  className="w-32 h-32 object-cover rounded"
                />
              </Link>

              <div className="absolute top-2 right-2">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuOpenId(
                      menuOpenId === match.user.id ? null : match.user.id
                    );
                  }}
                  className="p-1 hover:bg-gray-100 rounded-full"
                >
                  <FiMoreVertical size={18} />
                </button>
                {menuOpenId === match.user.id && (
                  <div className="absolute right-0 mt-2 w-40 bg-white border rounded shadow z-50">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUnblockProfile(match.user.id);
                        setMenuOpenId(null);
                      }}
                      className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                    >
                      Unblock Profile
                    </button>
                  </div>
                )}
              </div>

              <div className="flex-1">
                <Link
                  to={`/profile/${match.user.id}`}
                  className="flex-shrink-0 text-decoration-none"
                >
                  <p className="font-semibold text-lg">
                    {match.user.first_name} {match.user.last_name}
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    {calculateAge(match.dob)} yrs • {match.height_feet}'
                    {match.height_inches}" • {match.religion} •{" "}
                    {match.marital_status} • {match.highest_education} •{" "}
                    {match.employed_in} • {match.city}
                  </p>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlockProfilesListPage;
